import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer className="bg-gradient-to-r from-[#241c15] via-[#523323] to-[#7F6B52] w-full text-white pt-2 pb-0">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6 h-auto md:h-28 px-6 md:px-12 py-6 md:py-0">
                {/* Solda logo */}
                <Link to="/admin-login" className="flex-shrink-0 group">
                    <div className="backdrop-blur-md bg-white/10 border border-[#F9D923]/30 rounded-2xl px-3 py-2 flex items-center gap-2 shadow-lg group-hover:scale-105 group-hover:shadow-2xl transition-all duration-300">
                        <img
                            src={logo}
                            alt="Kirtepan Logo"
                            className="h-14 w-auto rounded-full drop-shadow-lg group-hover:drop-shadow-[0_0_20px_rgba(255,255,255,0.5)] transition-all duration-300"
                        />
                        <span className="hidden md:inline-block text-xl font-bold bg-gradient-to-r from-[#F9D923] via-[#FF914D] to-[#7F6B52] text-transparent bg-clip-text tracking-wider">Kirtepan</span>
                    </div>
                </Link>

                {/* Ortadaki ikonlar */}
                <div className="flex space-x-4">
                    <a
                        href="https://www.instagram.com/eng.cemgokce/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        className="p-2 bg-white/80 rounded-full flex items-center justify-center shadow hover:scale-110 hover:bg-[#F9D923]/80 transition-all duration-300 border border-[#F9D923]/30"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-[#523323] group-hover:text-[#F9D923] transition" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M7.75 2h8.5A5.75 5.75 0 0122 7.75v8.5A5.75 5.75 0 0116.25 22h-8.5A5.75 5.75 0 012 16.25v-8.5A5.75 5.75 0 017.75 2zm0 1.5A4.25 4.25 0 003.5 7.75v8.5A4.25 4.25 0 007.75 20.5h8.5a4.25 4.25 0 004.25-4.25v-8.5A4.25 4.25 0 0016.25 3.5h-8.5zm8.75 1.5a.75.75 0 011.5 0v1.5a.75.75 0 01-1.5 0V5zm-4.25 2.5a5 5 0 110 10 5 5 0 010-10zm0 1.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z" />
                        </svg>
                    </a>

                </div>

                {/* Sağdaki linkler */}
                <nav className="flex flex-col items-end space-y-3">
                    <Link to="/contact" className="text-sm font-semibold text-[#F9D923] hover:underline hover:text-[#FF914D] transition">İletişim</Link>
                    <Link to="/about" className="text-sm font-semibold text-[#F9D923] hover:underline hover:text-[#FF914D] transition">Hakkımızda</Link>
                    <Link to="/help" className="text-sm font-semibold text-[#F9D923] hover:underline hover:text-[#FF914D] transition">Yardım</Link>
                </nav>
            </div>
            {/* Telif hakkı metni */}
            <div className="bg-gradient-to-r from-[#241c15] via-[#523323] to-[#7F6B52] text-center py-4 text-sm text-[#F9D923] tracking-wide border-t border-[#F9D923]/20">
                © {year} <span className="font-bold text-[#FF914D]">Kirtepan Pansiyon</span>. Tüm hakları saklıdır.
            </div>
        </footer>
    );
}